<template>
  <client-only>
    <v-flex class="content-block" pt-4 pb-4 pl-2 pr-2>
      <v-layout wrap>
        <v-flex>
          <h6 class="display-18-16 mr-1 mb-2">{{ cvPopup.applientInfo }}</h6>
        </v-flex>
        <v-spacer />

        <v-flex class="text-left p-relative edit-details">
          <div>
            <p class="display-16">
              <span
                class="toggle-details pointer pc-view"
                @click="openEditDetails"
              >
                {{
                  editDetails ? cvPopup.closeEditDetails : cvPopup.editDetails
                }}
              </span>
              <span class="d-block d-sm-none">
                <v-icon
                  v-if="!editDetails"
                  x-large
                  class="icon-shape-1 display-22 v-align-text-top"
                  color="primary"
                  @click="openEditDetails"
                  v-ripple="false"
                />
                <v-icon
                  v-if="editDetails"
                  x-large
                  class="display-22 v-align-text-top"
                  color="primary"
                  @click="openEditDetails"
                  v-ripple="false"
                >
                  mdi-chevron-up
                </v-icon>
              </span>
            </p>
          </div>
        </v-flex>
      </v-layout>

      <CVUserDetails
        v-show="!editDetails"
        class="align-vertical"
        :AllowNoCV="AllowNoCV"
      />

      <CVUserDetailsEdit
        v-show="editDetails"
        ref="editor"
        class="align-vertical"
        :display-save="displaySave"
        :show-birth-year="false"
        @formValidated="handleValidation"
        :activateOtpOnPage="false"
      />
    </v-flex>
  </client-only>
</template>


<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import CVUserDetails from '@/components/Dialogs/CV_Popup/CVUserDetails';
import CVUserDetailsEdit from '@/components/Dialogs/CV_Popup/CVUserDetailsEdit';
import CurrentUser from '@/components/mixins/CurrentUser';

export default {
  mixins: [CurrentUser],
  components: {
    CVUserDetails,
    CVUserDetailsEdit,
  },

  props: {
    isCompleteDetails: {
      type: Boolean,
      default: false,
    },
    displaySave: {
      type: Boolean,
      default: false,
      required: false,
    },
    showEditDetails: {
      type: Boolean,
      default: false,
      required: false,
    },
    AllowNoCV: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  computed: {
    userDetails() {
      return this.CurrentUser;
    },
  },

  data() {
    return {
      cvPopup: t('titles.CV_Popup'),
      editDetails: false,
      inProgress: false,
      isValidForm: false,
    };
  },
  watch: {
    isValidForm(val) {
      this.$emit('enableSendCV', val);
    },
  },
  mounted() {
    this.fetchUser();

    /**
     * user details form will be open in-case user data is not completed
     * @param {Bollean} editDetails open edit form
     * @param {Boolean } isCompleteDetails prop from userdata
     */
    this.editDetails = !this.isCompleteDetails;

    this.$nuxt.$on('inProgress', this.updateProgress);
    this.$nuxt.$on('sendUpdated', this.saveDetails);
  },
  beforeDestroy() {
    this.$nuxt.$off('inProgress');
    this.$nuxt.$off('sendUpdated');
  },

  methods: {
    handleValidation(val) {
      this.isValidForm = val;
    },

    updateProgress(val) {
      this.inProgress = val;
    },

    openEditDetails() {
      this.editDetails = !this.editDetails;
    },

    saveDetails() {
      // collect all changes and send to update
      console.log('     // collect all changes and send to update');
      return this.$refs.editor.sendUpdatedDetails('sendCv');
    },

    async fetchUser() {
      await this.$auth.fetchUser();
      this.$emit('sendCV');
    },
  },
};
</script>

<style scoped lang="scss">
.is-disabled {
  color: red;
  pointer-events: none;
  background: none;
  border: 0;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.3);
}
.edit-details {
  margin-right: 30px;
}
.toggle-details {
  vertical-align: text-top;
  text-decoration: underline;
}
</style>
